
import React, { useEffect, useState } from "react";
import "../../assets/css/Studentinfo.css";
import axios from "axios";
import apiUrl from "../../environment/Api";
import { useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
// import "../../assets/css/updelete.css"

function Leadhistroy() {
  const { id } = useParams();
  const [lead, setLead] = useState([]);
  const [studentss, setStudent] = useState([]);
  const [idlocal, setLocalId] = useState("");
  const [previllages, setPrevillages] = useState({});
  const [roleId, setRoleId] = useState("");
  const [getDeleteId, setDeleteId] = useState("");
  const [getDeleteName, setDeleteName] = useState("");

  useEffect(() => {
    fetchDataed();
    const username = localStorage.getItem("username");

    setLocalId(username);
  }, [id]);

  const branchId = localStorage.getItem("branch_id");
  useEffect(() => {
    fetchRoleDetails();
  }, []);

  const fetchDataed = async () => {
    try {
      const response = await axios.get(`${apiUrl}/leadhistroy/${id}`);
      const responsed = await axios.get(`${apiUrl}/leads/${id}`);
      setLead(response.data);

      setStudent(responsed.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetchRoleDetails = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(`${apiUrl}/get_detail`, { token });
      const roleName = response.data.detail.rolename;
      setRoleId(roleName);
      localStorage.setItem("role_id", roleName);

      const roleResponse = await axios.get(`${apiUrl}/role_2/${roleName}`);
      const modules = roleResponse.data.modules;
      const branchAccess = modules.find((module) => module.name === "Enquiry");
      if (branchAccess) {
        setPrevillages(branchAccess.actions);
      }
    } catch (error) {
      console.error("Error fetching role details:", error.message);
    }
  };

  const handleDelete = async (id) => {
    // Check if the role is 'superadmin'

    try {
      await axios.delete(`${apiUrl}/leadhistroy/${id}`);
      fetchDataed();
    } catch (error) {
      console.error("Error deleting entry:", error.message);
    }

  };

  const handleOpenModal = (id, username) => {
    setDeleteId(id);
    setDeleteName(username);
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0];
  };




  return (
    <div className="marginup">
      <div className="row">
        <div className="col-lg-11">
          <Link to="/dashboard" className="text-secondary dashBoard_text">
            <b>Dashboard / </b>
          </Link>
          <Link to="/student" className="text-secondary dashBoard_text">
            <b>Leads / </b>
          </Link>
          <Link to="" className="text-danger dashBoard_text">
            <b>History</b>
          </Link>
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-lg-3">
          <h5>
            <b>Student Profile</b>
          </h5>
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-lg-3 col-sm-3 col-md-3">
          <div className="card carddetails p-2">
            <div className="imgdetails">
              <img
                className="profileimg"
                src={require("../../assets/img/icon.jpg")}
                alt="Profile"
              />
            </div>
            <div className="text-start mt-2 text-white">
              <h6 className="profile-detailsed">
                <i className="fa-solid fa-user px-3"></i>
                <b>{studentss[0]?.student_name}</b>
              </h6>
              <h6 className="profile-detailsed">
                <i className="fa-solid fa-phone px-3"></i>
                {studentss[0]?.mobile_no}
              </h6>
              <h6 className="profile-detailsed">
                <i className="fa-solid fa-id-card px-3"></i>
                {studentss[0]?.Prefered_course}
              </h6>
              <h6 className="profile-detailsed">
                <i className="fa-solid fa-book px-3"></i>
                {studentss[0]?.Source_type}
              </h6>
              <h6 className="profile-detailsed">
                <i className="fa-solid fa-calendar-days px-3"></i>
                {formatDate(studentss[0]?.Enquiry_date)}  - {(studentss[0]?.Enquiry_time)}
                {/* -{(lead?.Enquiry_time)} */}
              </h6>
              <h6 className="profile-detailsed">
                <i className="fa-solid fa-recycle px-3"></i> No. of Attempts: {lead.length}
              </h6>
            </div>
          </div>
        </div>

        <div className="col-lg-9 col-sm-9 col-md-9">
          <div className="row cardborder">
            <div className="card cardborder p-1">
              <div className="row p-2">
                <div className="col-lg-6">
                  <b>History</b>
                </div>
              </div>
            </div>

            <div className="card cardborder">
              <table className="table table-striped responsive">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Date</th>
                    <th>Contact Type</th>
                    <th>Duration</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Staff</th>
                    <th>Notes</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {lead.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{formatDate(item.Enquiry_date)}</td>
                      <td>{item.contact_type}</td>
                      {/* <td>{item.student_Id?.duration_time}</td> */}
                      <td>{item.duration_time}</td>
                      <td>{item.start_time}</td>
                      <td>{item.end_time}</td>
                      {/* <td>{item.assign_staff?.name}</td> */}
                      <td>
                        {branchId === "null" || branchId === null ? item.assign_staff?.name : idlocal || ""}
                      </td>
                      {/* <td>{idlocal || ""}</td> */}
                      <td>{item.notes}</td>
                      {/* <td>{item.status}</td> */}

                      {/* <td>
                        <span className={`badge ${item.status === 'Rescheduled' ? 'bg-primary' : 'bg-warning'}`}>
                          {item.status}
                        </span>
                      </td> */}

                      <td>
                        <span
                          className={`badge ${(() => {
                            const status = item.status.toLowerCase(); // Normalize to lowercase
                            switch (status) {
                              case 'unqualified':
                                return 'bg-danger';
                              case 'converted': // Now it handles both 'converted' and 'Converted'
                                return 'bg-success';
                              case 'rescheduled':
                                return 'bg-primary';
                              case 'qualified':
                                return 'bg-warning';
                              case 'notreachable':
                                return 'bg-dark';
                              case 'new':
                                return 'bg-info';
                              case 'walkin':
                                return 'bg-dark';
                              case 'scheduled':
                                return 'bg-secondary';
                              case "Phone Ringing":
                                return "#F0A04B"; // Black
                              // case 'Phone Ringing':
                              //   return {
                              //     backgroundColor: "rgb(240,160,75)",
                              //     color: "black",
                              //     padding: "2px 8px",
                              //     borderRadius: "5px"
                              //   };
                              default:
                                return ''; // default case if status doesn't match any known ones
                            }
                          })()}
  `}
                          style={{ width: '100%' }}
                        >
                          {item.status}
                        </span>
                      </td>



                      {/* <td className={getStatusLabelClass(item.status)}>
                        <span>{item.status}</span>
                      </td> */}


                      <td className="text-center">
                        {/* Check if the role is not 'superadmin' */}
                        {/* {item.role_detail?.rolename !== "superadmin" && */}
                        {/* previllages.delete && ( */}
                        <button
                          className="btn delete"
                          onClick={() =>
                            handleDelete(item._id, item)
                          }
                        >
                          <i className="fa-solid fa-trash-can"></i>
                        </button>
                        {/* // )} */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Leadhistroy;
